export function normalizeTrainingRecord(record = {}) {
  const normalized = { ...record };
  normalized.saved = normalized.saved ?? normalized.favorite ?? false;
  delete normalized.favorite;
  return normalized;
}

export function normalizeTrainingData(training = {}) {
  return Object.fromEntries(
    Object.entries(training)
      .filter(([id]) => id !== 'type')
      .map(([id, record]) => [id, normalizeTrainingRecord(record)])
  );
}
